import { render, staticRenderFns } from "./FaqNewVersion.vue?vue&type=template&id=4786d3b4&"
import script from "./FaqNewVersion.vue?vue&type=script&lang=js&"
export * from "./FaqNewVersion.vue?vue&type=script&lang=js&"
import style0 from "./FaqNewVersion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports